import f from "./design-system.es58.js";
import { resolveComponent as d, openBlock as o, createElementBlock as n, withModifiers as x, renderSlot as c, mergeProps as v, createElementVNode as u, normalizeClass as s, toDisplayString as y, createBlock as a, createCommentVNode as l, createTextVNode as h, withCtx as S, createVNode as P } from "vue";
/* empty css                    */
import B from "./design-system.es128.js";
import I from "./design-system.es109.js";
import w from "./design-system.es290.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
const C = {
  name: "DsMultiSelectMenuItem",
  components: {
    Icon: f,
    TextHighlighter: I,
    MenuItemSubtext: w
  },
  props: {
    /**
     * Enables dense menu items
     */
    dense: Boolean,
    disabledOptionProp: {
      type: String,
      default: "disabledOption"
    },
    filter: {
      type: String,
      default: ""
    },
    helpText: Boolean,
    helpTextProp: {
      type: String,
      default: "helpText"
    },
    index: Number,
    isBreadcrumb: Boolean,
    isCategory: Boolean,
    labelProp: {
      type: String,
      default: "label"
    },
    option: Object,
    pointer: Number,
    selected: [Object, Array],
    showOptionModifierProp: String,
    valueProp: {
      type: String,
      default: "value"
    }
  },
  emits: [
    "mouseover",
    "select-option"
  ],
  computed: {
    highlight() {
      return !this.isBreadcrumb && !this.option.isLabel && (this.isCategory || !this.option[this.disabledOptionProp]) && this.index === this.pointer;
    },
    icon() {
      return this.isBreadcrumb ? "chevron-left" : this.option.icon;
    },
    isSelected() {
      return !this.isCategory && !this.option.isLabel && this.selected && this.selected[this.valueProp] === this.option[this.valueProp];
    },
    label() {
      return this.isCategory ? this.option.label : this.option[this.labelProp];
    },
    labelClass() {
      return this.isCategory && !this.isBreadcrumb ? "category-label" : "option-text";
    },
    showHelpText() {
      return this.helpText && !!this.option[this.helpTextProp];
    },
    showIconPrefix() {
      return this.isBreadcrumb || !!this.option.icon;
    },
    showIconSuffix() {
      return !this.isBreadcrumb && this.option.hasChildrenOptions;
    }
  }
}, T = ["data-qa"], M = ["data-qa"], k = ["data-qa"], O = { key: 1 };
function _(r, i, e, q, L, t) {
  const m = d("Icon"), p = d("TextHighlighter"), b = d("MenuItemSubtext");
  return o(), n("li", {
    class: "menu-item-root",
    "data-qa": t.label,
    onClick: i[0] || (i[0] = x((g) => r.$emit("select-option", e.option), ["prevent", "stop"])),
    onMouseover: i[1] || (i[1] = (g) => r.$emit("mouseover", e.index))
  }, [
    c(r.$slots, "default", v(r.$props, {
      highlight: t.highlight,
      isSelected: t.isSelected
    }), () => [
      u("div", {
        class: s(["menu-item", "prevent-select", {
          label: e.isBreadcrumb || e.option.isLabel,
          "option-text-disabled": e.option[e.disabledOptionProp],
          "has-icon": t.showIconPrefix,
          breadcrumb: e.isBreadcrumb,
          selected: t.isSelected,
          separator: e.option.separator,
          highlight: t.highlight,
          dense: e.dense
        }])
      }, [
        e.option.groupLabel ? (o(), n("div", {
          key: 0,
          class: "section-header prevent-select",
          "data-qa": e.option.groupLabel
        }, y(e.option.groupLabel), 9, M)) : (o(), n("div", {
          key: 1,
          class: s(["option-row", "prevent-select", { "has-help-text": e.helpText }]),
          "data-qa": t.label
        }, [
          t.showIconPrefix ? (o(), a(m, {
            key: 0,
            class: "category-icon",
            name: t.icon
          }, null, 8, ["name"])) : l("", !0),
          i[3] || (i[3] = h()),
          u("div", {
            class: s(t.labelClass)
          }, [
            t.label ? (o(), a(p, {
              key: 0,
              highlight: e.filter,
              content: t.label,
              class: s({ "option-text-disabled-label": e.option[e.disabledOptionProp] })
            }, null, 8, ["highlight", "content", "class"])) : l("", !0),
            i[2] || (i[2] = h()),
            t.showHelpText ? (o(), a(b, {
              key: 1,
              selected: t.isSelected
            }, {
              default: S(() => [
                P(p, {
                  highlight: e.filter,
                  content: e.option[e.helpTextProp]
                }, null, 8, ["highlight", "content"])
              ]),
              _: 1
            }, 8, ["selected"])) : l("", !0)
          ], 2),
          i[4] || (i[4] = h()),
          e.option[e.showOptionModifierProp] ? (o(), n("div", O, [
            c(r.$slots, "optionModifier")
          ])) : l("", !0),
          i[5] || (i[5] = h()),
          t.showIconSuffix ? (o(), a(m, {
            key: 2,
            class: "chevron category-arrow",
            name: "chevron-right"
          })) : l("", !0)
        ], 10, k))
      ], 2)
    ])
  ], 40, T);
}
const pe = /* @__PURE__ */ B(C, [["render", _], ["__scopeId", "data-v-a8ec3671"]]);
export {
  pe as default
};
//# sourceMappingURL=design-system.es81.js.map
